import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OpsService } from '../../../Services/ops.service';

@Component({
  selector: 'app-ops-list',
  templateUrl: './ops-list.component.html',
  styleUrls: ['./ops-list.component.css']
})
export class OpsListComponent implements OnInit,AfterViewInit {

  public OpsListHeader: String[] = ["tempOpsNum", "opsNum", "business", "opsDate", "companyName"];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
     public dialogRef: MatDialogRef<OpsListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _OpsService:OpsService,
     private intl: MatPaginatorIntl,
     private changeDectector: ChangeDetectorRef
    ) { 

      this.sort = new MatSort();
      this.paginator = new MatPaginator(this.intl, this.changeDectector);
    }

  ngOnInit(): void {
    this.GetOpsListByRefIdForSpra();
    }

    ngAfterViewInit(): void {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }
  

    GetOpsListByRefIdForSpra(){

      if(this.data){
        this._OpsService.GetOpsListByRefIdForSpra(this.data.refId).subscribe((d:any)=>{
          this.dataSource.data = d;
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          });
        });
      }
      
    }

    OnOpsClick(ops:any){
      this.dialogRef.close({data:ops});
    }
  
    closeDialog(){
      this.dialogRef.close({event:'Cancel'});
    }

}
